module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="loading-bar-container">\n    <div class="loading-bar"></div>\n</div>\n<div class="name">' +
__e( name ) +
'</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/editor/sceneLoadingScreen/UploadBarView.tpl
// module id = 2981
// module chunks = 0